
import { of,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';


let counter = 0;

@Injectable()
export class UserService {

  private users = [
    {platformUserId: 1, name: 'Nick Jones', picture: 'assets/images/nick.png' },
    {platformUserId: 2, name: 'Eva Moor', picture: 'assets/images/eva.png' },
    {platformUserId: 3, name: 'Jack Williams', picture: 'assets/images/jack.png' },
    {platformUserId: 4, name: 'Lee Wong', picture: 'assets/images/lee.png' },
    {platformUserId: 5, name: 'Alan Thompson', picture: 'assets/images/alan.png' },
    {platformUserId: 6, name: 'Kate Martinez', picture: 'assets/images/kate.png' },
  ];

  private userArray: any[];

  constructor() {
    // this.userArray = Object.values(this.users);
  }

  getUsers(): Observable<any> {
    return of(this.users);
  }

  getUserArray(): Observable<any[]> {
    return of(this.userArray);
  }

  getUser(): Observable<any> {
    counter = (counter + 1) % this.userArray.length;
    return of(this.userArray[counter]);
  }
}
